<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{cont.name}}</div>
        </div> 
        <div class="cont-box">
            <div id="echart" class="chart-box"></div>
            <div class="tips">{{this.$t('pay.kjxx')}}</div>
            <ul class="ul-box">
                <li class="list">
                    <img class="img" :src="cont.img_url" alt="">
                    <div class="info-box">
                        <div class="title">{{cont.name}} <span class="red">{{$t('wdkj.xg')}}{{cont.limit_buy}}{{$t('wdkj.tai')}}</span></div>
                        <div class="price-box">
                            <div class="text1">{{$t('wdkj.jg')}}{{cont.money}}USDT</div>
                            <div class="text2">{{$t('wdkj.wkts')}}{{cont.coin_cycle}}{{$t('wdkj.day')}}</div>
                        </div>
                        <div class="sl-box">
                            <div class="text1">{{$t('wdkj.sl')}}{{cont.cp_num}}T</div>
                                <div class="text2">{{$t('wdkj.rwk')}}{{cont.btcm_money}} GDCC</div>
                        </div>
                    </div>
                </li>            
            </ul>
            <div class="num-wrap">
                <div>{{$t('pay.gmsl')}}</div>
                <div class="num-box">
                    <img class="icon" src="@/assets/Less.png" @click="jian" alt="">
                    <div><input class="input" v-model="amount" type="number" min="1"  @keyup="keyAmount()" autocomplete="off"></div>
                    <img class="icon" src="@/assets/Plus.png" @click="add" alt="">
                </div>
            </div>
            <div class="pay-box">
                <div class="t1">{{$t('pay.kyye')}} <span class="red">{{usdt_money}}<small>USDT</small></span></div>
                <div class="t2" @click="pay">{{$t('pay.zf')}}{{totlaMoney}}</div>
            </div>
        </div>
        <div class="mask" v-show="isMask"></div>
        <div class="alert-box" v-show="isShow">
            <div class="alert-head">{{$t('usdttb.qsrjymm')}}</div>
            <img class="close" src="@/assets/close.png" @click="close2" alt="">
            <ul class="pwd-box">
                <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>               
            </ul>
        </div>        
        <!-- 审核失败 -->
        <div class="alert-wrap" v-show="isShenHe">
            <div class="alert-head">
                {{this.$t('pay.wxts')}}
                <img class="icon" src="@/assets/close.png" @click="close" alt="">
            </div>
            <div class="cont">{{tips}}</div>
        </div>
        <!-- 支付设置 -->
        <div class="alert-wrap alert-pay" v-show="isPay">
            <div class="alert-head">
                {{this.$t('tips.zfts')}}                          
            </div>
            <div class="alert-btn" @click="sure">{{this.$t('wdkj.sure')}}</div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'pay',
    data () {
        return {
            isShow: false,
            isShenHe: false,
            isMask: false,
            isPay: false,
            isPwdError: false,
            tips: '',
            uid: '',
            token: '',
            usdt_money: 0,
            cont: {},
            rwkArr: [],
            cycleArr: [],
            amount: 1,
            totlaMoney: 0,
            inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],            
        }
    },
    created(){
        this.cont = JSON.parse(localStorage.getItem('index'));
        this.totlaMoney = this.cont.money;
        this.uid = localStorage.getItem('uid');
        this.token = localStorage.getItem('token'); 
    },
    mounted(){
        this.getRandom();
        this.initEchart();
        this.init();
        this.getMemberInfo();
    },
    methods: { 
        getRandom(){
            let cycle = this.cont.coin_cycle;
            let daywk = this.cont.btcm_money;
            let cycleCount = 5;
            let junday =  cycle / cycleCount;     
            for(var i=1;i <= cycleCount; i++){
                if(i == cycleCount ){
                    this.rwkArr.push((daywk * cycle).toFixed(2));
                    this.cycleArr.push(cycle + this.$t('wdkj.day'))                  
                    break;
                }
                let nowday = parseInt(junday * ((((i+2)/cycleCount*4)/2*(1+(i/(cycleCount+((i-(cycleCount-i)/cycleCount))))))/(cycleCount/i)))+1 ;
                this.rwkArr.push((daywk * nowday).toFixed(2));
                this.cycleArr.push(nowday + this.$t('wdkj.day'))
            } 
            console.log(this.rwkArr);
            console.log(this.cycleArr)
        },
        initEchart(){
            var dom = document.getElementById("echart");
            var myChart = echarts.init(dom);           
            var option = null;  
            option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },                
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                lineStyle:{
                        color:'#839FCE'
                },
                xAxis: {
                    type: 'category',
                    data: this.cycleArr,
                    splitLine:{show: false},
                    axisLine: {  // 控制x轴线的样式
                          lineStyle: {
                            type: 'solid',
                            color: '#839FCE',
                            width:'1' 
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    color: '#839FCE',
                    splitLine:{show: false},                   
                    scale : true,
                    max : this.rwkArr[4],
                    min : 0,                    
                    splitNumber : 5,                    
                    axisLine: {  // 控制x轴线的样式
                          lineStyle: {
                            type: 'solid',
                            color: '#839FCE',
                            width:'1' 
                        }
                    },
                },
                series: [{                    
                    data: this.rwkArr,
                    type: 'line',
                    smooth: true
                }]
            };
            if (option && typeof option === "object") {
                option && myChart.setOption(option);
            }
        },
        init(){
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/Member/checkMoneyPass',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){ 
                    this.isMask = false;                  
                    this.isPay = false;              
                }else{
                    this.isMask = true;
                    this.isPay = true;                     
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },
        getMemberInfo(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/member/getMemberInfo',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){                   
                    this.usdt_money = resData.usdt_money;              
                }else{
                    this.$router.push('/login')
                    // this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },  
        jian(){
            if(this.amount > 1){
                this.amount --;
                this.totlaMoney = this.amount * this.cont.money
            }
        },
        add(){
            if(this.amount < this.cont.limit_buy){
                 this.amount ++;
            }           
            this.totlaMoney = this.amount * this.cont.money
        }, 
        nextFocus(el,index) {
            console.log(index)
            var dom = document.getElementsByClassName("pwd-input"),
                currInput = dom[index],
                nextInput = dom[index + 1],
                lastInput = dom[index - 1];
            /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
            if (el.keyCode != 8) {
                if (index < (this.inputList.length - 1)) {
                    nextInput.focus();
                } else {
                    currInput.blur();
                }
            }else{
                if (index != 0) {
                    lastInput.focus();
                }
            }
            let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
            if(password.length == 6){
                let params = {
                    uid: this.uid,
                    token: this.token,
                    mm_id: this.cont.mm_id,
                    money_password: password,
                    mm_num: this.amount
                }
                this.$ajax.post('/api/Mmorder/buyMm',params).then((res) => { 
                    if(res.data.code == 200){
                        this.$toast.bottom(this.$t('pay.gmcg'));  
                        this.isShow = false; 
                        this.isPwdError = false;
                        this.$router.push('/index');
                    }else if(res.data.code == 40006){
                        this.isShow = false;
                        this.isMask = true;
                        this.isShenHe = true;
                        this.isPwdError = true;
                        this.tips = res.data.msg;                        
                    }else{
                        this.isShow = false;
                        this.isMask = false;
                        this.isShenHe = false;
                        this.isPwdError = false;
                        this.$toast.bottom(res.data.msg);
                    }
                }).catch(function(err){
                    console.log(err);                
                })      
            }else{
                return false;
            }
        },
        pay(){
            if(this.totlaMoney > this.usdt_money){
                this.$toast.bottom(this.$t('pay.kyyebz'));  
                return false;
            }
            this.isMask = true;
            this.isShow = true;   
            this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}]       
        },
        keyPwd(){			
			this.amount = this.amount.replace(/[^\d]/g, "");  //仅保留数字
			this.amount = this.amount.replace(/\./g, "");
		},
        keyAmount(){			
			this.amount = this.amount.replace(/^(0+)|[^\d]+/g,'');  //仅保留数字"				
		},
        close(){
            if(this.isPwdError){
                this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}]
                this.isShenHe = false;
                this.isShow = true;
                this.isMask = true;
            }else{
                this.isShow = false;
                this.isMask = false;
                this.isShenHe = false;
            }            
        },
        close2(){
            this.isShow = false;
            this.isMask = false;
        },
        sure(){
            this.isPay = false;
            this.isMask = false;
            this.$router.push('/ModifyCashPwd');
        },
        goBack(){
            this.$router.push('/kjlb');
        },       
    },
    filters: {        
        toFixed: function(val){           
            return val.toFixed(4)
        }
    },
    watch: {
        amount: function(val){
            console.log(val)
            if(val > this.cont.limit_buy){
                this.amount = this.cont.limit_buy;
            }else if(val == ''){
                this.amount = '';
            }else if(val == 0){
                this.amount = 1;
            }else{
                this.amount = val;
            }            
        }        
    },
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;  
        color: #cecece;     
        font-size: .24rem;  
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
        overflow: hidden;       
    }    
    .head{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: .8rem;
        font-size: .36rem;
        line-height: .8rem;
        text-align: center;
    }   
    .head .icon{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .24rem;
        height: .44rem;
        transform: translateY(-50%);        
    } 
    .cont-box{
        position: absolute;
        left: 0;
        top: .8rem;
        bottom: 0;
        width: 100%;
        height: auto; 
        padding: 0 .24rem; 
        box-sizing: border-box;      
    }  
    .chart-box{
        width: 7rem;
        height: 4rem;        
        box-sizing: border-box;
    }
    .cont-box .tips{
        padding: 0 0 .2rem;
        color: #fff;
        font-size: .32rem;
    }
    .ul-box{
        padding: .24rem 0;
    }
    .ul-box .list{   
        display: flex;  
        align-items: center;
        margin-bottom: .24rem;
        padding: .34rem .18rem .34rem .24rem;   
        /* background: #040925; */
        background: rgb(4 ,9 ,37,.5);
        border-radius: .1rem;
    }
    .ul-box .list .img{
        width: 1.25rem;
        height: .96rem;
    }
    .ul-box .list .info-box{
        flex: 1;
        margin-left: .28rem;
        color: #cecece;
        font-size: .24rem;
    }
    .ul-box .list .info-box .title{
        color: #fff;
        font-size: .28rem;
    }
    .ul-box .list .info-box .title .red{
        padding-left: .06rem;
        color: #E02626;
        font-size: .24rem;
    }
    .ul-box .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .3rem;
    }
    .ul-box .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .18rem;
    }
    .ul-box .list .info-box .text1{
        width: 50%;
    }
    .ul-box .list .info-box .text2{
        width: 50%;
    }
    .num-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .32rem .42rem; 
        color: #fff;  
        font-size: .28rem;     
        /* background: #040A26; */
        background: rgba(4, 10, 38,.5);
        border-radius: .46rem;
    }
    .num-wrap .icon{
        width: .38rem;
        height: .38rem;
    }
    .num-box{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .num-box .input{
        width: .8rem;
        color: #fff;
        font-size: .28rem;
        background: #040A26;
        text-align: center;
    }
    .pay-box{
        position: absolute;
        bottom: .64rem;
        left: .24rem;
        right: .24rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: auto;
        height: .9rem; 
        color: #fff;  
        line-height: .9rem;  
        font-size: .28rem;     
        background: #040A26;
        border-radius: .46rem;
    }
    .pay-box .t1{
        width: 60%;
        padding-left: .2rem;
    }
    .pay-box .t1 .red{
        padding-left: .16rem;
        color: #2CAADE;
        font-size: .26rem;
    }
    .pay-box .t1 small{
        font-size: .28rem;  
    }
    .pay-box .t2{
        width: 40%;   
        height: .9rem;   
        font-size: .34rem;        
        /* background: #2CAADE; */
        background: rgba(44, 170, 222,.5);
        border-radius: 0 .46rem .46rem 0;
        text-align: center;
    }
    .alert-box{
        position: absolute;
        left: .92rem;
        right: .95rem;
        top: 50%;
        z-index: 1000;
        width: auto;  
        padding: .26rem .66rem .68rem .66rem;      
        background: #374C7C;
        border-radius: .07rem;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .alert-box .alert-head{
        position: relative;
        color: #fff;
        font-size: .28rem;
        text-align: center;
    }
    .alert-box .close{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .24rem;
        height: .24rem;
    }
    .alert-box .pwd-box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .5rem;
        border: 1px solid #fff;
    }
    .alert-box .pwd-box .pwd{
        flex: 1;
        height: .7rem;        
    }
    .alert-box .pwd-box .pwd .input{
        width: 100%;
        height: .7rem;
        color: #fff;
        border-right: 1px solid #fff;
        background: #374C7C;
        text-align: center;
        box-sizing: border-box;
        border-radius: 0;
        outline: none;
    }
    .alert-box .pwd-box .pwd:last-child .input{
        border-right: none;
    }
    .alert-wrap{
        position: absolute;
        left: 1.3rem;
        right: 1.18rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap .alert-head,.alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap .alert-head .icon,.alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap .cont{
        max-height: 6rem;
        padding: 0 .8rem .72rem .72rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .alert-pay{
        background: #1a243f;
    }
    .alert-pay .alert-head{
        padding: .5rem .4rem;
        font-size: .28rem;
        border-bottom: 1px solid #858585;
    }
    .alert-pay .alert-btn{
        padding: .3rem 0;
        color: #2CAADE;
        font-size: .32rem;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/pages/pay.vue